// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowListModal-cls1___6097a39491cdccebc37{/*!*/}.BulkFollowListModal-cls2__e79fc2ad904403e9aeb5{display:flex;max-width:427px;width:100%;margin:0 auto;font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowListModal-cls1___6097a39491cdccebc37",
	"cls2": "BulkFollowListModal-cls2__e79fc2ad904403e9aeb5 BulkFollowListModal-cls1___6097a39491cdccebc37"
};
export default ___CSS_LOADER_EXPORT___;
